var _defs, _path, _path2, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew291({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.74,13.5,4.05,9.36h.48L5.92,13.5H5.4L5,12.25H3.58L3.21,13.5Zm1-1.7H4.87l-.35-1.15c-.11-.35-.19-.63-.24-.85a7.55,7.55,0,0,1-.19.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.69,6.14V2H12a2.21,2.21,0,0,1,.67.08.85.85,0,0,1,.46.4,1.31,1.31,0,0,1,.18.71A1.4,1.4,0,0,1,13,4.1a1.17,1.17,0,0,1-1,.36h-.87V6.14ZM11.14,4H12a.8.8,0,0,0,.6-.19.74.74,0,0,0,.2-.57.93.93,0,0,0-.1-.42.59.59,0,0,0-.23-.24A1.32,1.32,0,0,0,12,2.49h-.87Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 1,
    y1: 0.73,
    x2: 15,
    y2: 0.73
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 1,
    y1: 14.73,
    x2: 15,
    y2: 14.73
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8,
    y1: 0.73,
    x2: 8,
    y2: 14.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew291);
export default __webpack_public_path__ + "static/media/Symbolpack_New_291.122183bff1bc6361e19748ca3c744c54.svg";
export { ForwardRef as ReactComponent };